export default "__VITE_ASSET__8c4f3ada__"